import * as Types from '@crimeos-frontend/crime-os/graphql';

import { gql } from '@apollo/client';
import { GetSignalRAccessTokenResultFragmentDoc } from '@crimeos-frontend/crime-os/graphql-docs';
import * as Apollo from '@apollo/client';
export type GetSignalRAccessTokenQueryVariables = Types.Exact<{
  params: Types.GetSignalRAccessTokenParams;
}>;


export type GetSignalRAccessTokenQuery = { __typename: 'Query', getSignalRAccessToken: { __typename: 'GetSignalRAccessTokenResult', accessToken: string, url: string, expiresAt: string } };


export const GetSignalRAccessTokenDocument = gql`
    query GetSignalRAccessToken($params: GetSignalRAccessTokenParams!) {
  getSignalRAccessToken(params: $params) {
    ... on GetSignalRAccessTokenResult {
      ...GetSignalRAccessTokenResult
    }
  }
}
    ${GetSignalRAccessTokenResultFragmentDoc}`;
export type GetSignalRAccessTokenQueryResult = Apollo.QueryResult<GetSignalRAccessTokenQuery, GetSignalRAccessTokenQueryVariables>;